<template>
  <custom-modal v-model="showAddMatchDialog" :confirm-button-loading="isAddMatchLoading" @confirm="saveMatch" @cancel="$emit('close')">
    <template v-slot:title>{{ formAction }} match to track</template>
    <div class="mb-3 mt-4">
      <input type="text" name="id" v-model="form.match_id" class="form-control" placeholder="Match ID">
    </div>
    <div class="mb-3 mt-4">
      <input type="text" name="match_name" v-model="form.match_name" class="form-control" placeholder="Match Name">
    </div>
    <div class="mb-3 mt-4">
      <textarea type="text" name="notes" v-model="form.notes" class="form-control" placeholder="Notes"></textarea>
    </div>

    <base-alert v-show="form.has_error" type="info">
        <span>{{form.error_message}}</span>
    </base-alert>
  </custom-modal>
</template>

<script>
import axios from "axios";
import { BaseAlert } from '@/components';
import CustomModal from "../components/CustomModal.vue";
export default {
  props: {
    showAddMatchDialog: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({
        match_id: '',
        match_name: '',
        notes: '',
        has_error: false,
        error_message: '',
      })
    },
    formAction: {
      type: String,
      default: 'Add'
    }
  },
  components: {
    CustomModal,
    BaseAlert,
  },
  data() {
    return {
      isAddMatchLoading: false,
    }
  },
  methods: {
    saveMatch() {
      this.isAddMatchLoading = true;
      // Assuming 'matches-to-track' is the endpoint for adding a match to track
      axios.post('tracked-games', { match_id: this.form.match_id, notes: this.form.notes, match_name: this.form.match_name })
      .then(response => {
          this.isAddMatchLoading = false;
          this.$toast.success("Added successfully");
          this.$emit('close');
          this.$emit('added');
      })
      .catch(error => {
          console.log(error);
          this.$toast.error("Error adding match");
          this.isAddMatchLoading = false;
          this.form.error_message = error.response.data.message;
          this.form.has_error = true;
      });
    },
  },
}
</script>
